var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clubs-summary',{attrs:{"id":"summary"}}),_c('use-car',{attrs:{"id":"car"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }